import {useAlive} from '@github-ui/use-alive'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import throttle from 'lodash-es/throttle'
import {useEffect, useMemo} from 'react'

const THROTTLE_INTERVAL_MS = 10_000

/**
 * Subscribes to the task-scoped Alive channel and triggers a callback on events.
 * Gated on the `copilot_task_scoped_alive_channel` feature flag.
 *
 * The task channel carries metadata-only payloads (state, session_id, event_type)
 * so consumers use the callback to invalidate/refetch the data they care about.
 */
export function useTaskAliveUpdates(taskAliveChannel: string | undefined, onUpdate: () => void) {
  const throttledUpdate = useMemo(
    () => throttle(onUpdate, THROTTLE_INTERVAL_MS, {leading: false, trailing: true}),
    [onUpdate],
  )

  useEffect(() => () => throttledUpdate.cancel(), [throttledUpdate])

  const enabled = isFeatureEnabled('copilot_task_scoped_alive_channel')
  const channel = enabled ? taskAliveChannel : undefined

  useAlive(channel, throttledUpdate)
}
